import { api } from './api';
export const projectsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // 获取项目列表
        getProjects: builder.query({
            query: (params) => ({
                url: '/projects',
                params,
            }),
            providesTags: (result) => result
                ? [
                    ...result.items.map(({ id }) => ({ type: 'Project', id })),
                    { type: 'Project', id: 'LIST' },
                ]
                : [{ type: 'Project', id: 'LIST' }],
        }),
        // 获取单个项目
        getProject: builder.query({
            query: (id) => `/projects/${id}`,
            providesTags: (result, error, id) => [{ type: 'Project', id }],
        }),
        // 创建项目
        createProject: builder.mutation({
            query: (data) => ({
                url: '/projects',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: [{ type: 'Project', id: 'LIST' }],
        }),
        // 更新项目
        updateProject: builder.mutation({
            query: ({ id, data }) => ({
                url: `/projects/${id}`,
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: (result, error, { id }) => [{ type: 'Project', id }],
        }),
        // 删除项目
        deleteProject: builder.mutation({
            query: (id) => ({
                url: `/projects/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [{ type: 'Project', id: 'LIST' }],
        }),
        // 保存剧本
        saveScript: builder.mutation({
            query: ({ projectId, content }) => ({
                url: `/projects/${projectId}/script`,
                method: 'PUT',
                body: { content },
            }),
            invalidatesTags: (result, error, { projectId }) => [{ type: 'Project', id: projectId }],
        }),
        // 发布项目
        publishProject: builder.mutation({
            query: ({ id, publishData }) => ({
                url: `/projects/${id}/publish`,
                method: 'POST',
                body: publishData,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'Project', id },
                { type: 'Project', id: 'LIST' },
            ],
        }),
        // AI生成剧本
        generateScript: builder.mutation({
            query: ({ projectId, topic, style }) => ({
                url: `/projects/${projectId}/generate-script`,
                method: 'POST',
                body: { topic, style },
            }),
            invalidatesTags: (result, error, { projectId }) => [{ type: 'Project', id: projectId }],
        }),
    }),
});
export const { useGetProjectsQuery, useGetProjectQuery, useCreateProjectMutation, useUpdateProjectMutation, useDeleteProjectMutation, useSaveScriptMutation, usePublishProjectMutation, useGenerateScriptMutation, } = projectsApi;
